import { X } from 'lucide-react'

export default function InfoModal({ isOpen, title, content, onClose }) {
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 border border-slate-700 rounded-xl w-full max-w-md shadow-2xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-white">{title}</h3>
          <button onClick={onClose} className="text-slate-500 hover:text-white"><X size={20} /></button>
        </div>
        <div className="text-slate-300 whitespace-pre-line">{content}</div>
        <div className="flex justify-end mt-6">
          <button onClick={onClose} className="bg-slate-800 hover:bg-slate-700 px-6 py-2 rounded-lg text-white font-bold shadow-lg transition">Fechar</button>
        </div>
      </div>
    </div>
  )
}
